import React, { useEffect } from "react";
import { useNavigate } from "react-router-dom";
import styled from "styled-components";
import { motion } from "framer-motion";
import { useMediaQuery } from "react-responsive";
import Cookies from "js-cookie";
const CompletePage = () => {
  const navigate = useNavigate();
  const isDesktop = useMediaQuery({ minWidth: 768 });

  // 애니메이션 변수
  useEffect(() => {
    Object.keys(Cookies.get()).forEach((cookie) => {
      Cookies.remove(cookie);
    });
  }, []);
  const pageVariants = {
    initial: {
      opacity: 0,
    },
    in: {
      opacity: 1,
      transition: {
        duration: 0.5,
      },
    },
    out: {
      opacity: 0,
      transition: {
        duration: 0.3,
      },
    },
  };

  const contentVariants = {
    initial: {
      opacity: 0,
      y: 20,
    },
    in: {
      opacity: 1,
      y: 0,
      transition: {
        duration: 0.6,
        delay: 0.2,
        staggerChildren: 0.1,
      },
    },
  };

  const openKakaoLink = () => {
    window.open(
      "https://open.kakao.com/o/gRAHORth?utm_source=SKT&utm_medium=web_info&utm_campaign=web_info_last",
      "_blank"
    );
  };

  return (
    <PageBackground>
      <Container
        variants={pageVariants}
        initial="initial"
        animate="in"
        exit="out"
      >
        <Content variants={contentVariants} initial="initial" animate="in">
          <StatusBadge>접수완료</StatusBadge>

          <MainContent>
            <Title>
              SKT 유심 개인정보 유출 사고
              <br />
              집단소송 접수가 완료되었습니다.
            </Title>
          </MainContent>

          <IconContainer>
            <CompleteIcon src="/png/completIcon.png" alt="완료 아이콘" />
          </IconContainer>
          <CompleteButtonContainer>
            <CompleteButton onClick={() => navigate("/select")}>
              완료하기
            </CompleteButton>
            {/* <KakaoButton onClick={openKakaoLink}>
              <KakaoButtonImage src="/png/kakaoOpen2.png" alt="카카오 열기" />
            </KakaoButton> */}
          </CompleteButtonContainer>
        </Content>
      </Container>
    </PageBackground>
  );
};

// 스타일 컴포넌트
const PageBackground = styled.div`
  width: 100%;
  min-height: 100vh;
  background-color: #f8f8f8;
  display: flex;
  justify-content: center;
  align-items: center;
  padding: 0;

  @media (min-width: 769px) {
    padding: 20px;
    background-color: #fff;
  }
`;

const Container = styled(motion.div)`
  position: relative;
  width: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: flex-start;
  background-color: #f8f8f8;

  /* 모바일 디바이스 */
  @media (max-width: 768px) {
    min-height: 100vh;
    box-shadow: none;
    padding: 0;
    max-width: 100%;
    margin: 0;
    border-radius: 0;
  }

  /* 데스크탑 디바이스 */
  @media (min-width: 768px) {
    background-color: #ffffff;
    border-radius: 20px;
    min-height: 700px;
    max-width: 470px;
    margin: 0 auto;
    box-shadow: 0 0 20px rgba(0, 0, 0, 0.2);
    padding: 20px;
  }
`;

const Content = styled(motion.div)`
  display: flex;
  flex-direction: column;
  width: 100%;
  height: 100%;
  position: relative;
  padding: 40px 20px;

  @media (max-width: 768px) {
    min-height: 100vh;
  }

  @media (min-width: 769px) {
    min-height: 700px;
  }
`;

const StatusBadge = styled.div`
  background-color: #d7e6ff;
  color: #4071ed;
  font-size: 14px;
  font-weight: 600;
  padding: 6px 16px;
  border-radius: 4px;
  display: inline-block;
  margin-bottom: 40px;
  align-self: flex-start;
`;

const IconContainer = styled.div`
  display: flex;
  justify-content: center;
  width: 100%;
`;

const CompleteIcon = styled.img`
  width: 200px;
  height: 200px;
  object-fit: contain;
`;

const MainContent = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  width: 100%;
  margin-bottom: auto;
`;

const Title = styled.h1`
  font-size: 24px;
  font-weight: 700;
  line-height: 1.4;
  margin-bottom: 15px;
  color: #2e3840;
  text-align: left;
`;

const SubTitle = styled.p`
  font-size: 16px;
  font-weight: 400;
  line-height: 1.5;
  color: #6c757d;
  text-align: left;
`;

const CompleteButtonContainer = styled.div`
  width: 100%;
  margin-top: auto;
  padding-bottom: 50px;
  display: flex;
  flex-direction: column;
  gap: 10px;
`;

const CompleteButton = styled.button`
  display: flex;
  justify-content: center;
  align-items: center;
  background-color: #007bff;
  color: white;
  width: 100%;
  height: 56px;
  border-radius: 8px;
  font-size: 18px;
  font-weight: 600;
  cursor: pointer;
  border: none;
  transition: background-color 0.2s;

  &:hover {
    background-color: #0069d9;
  }
`;

const KakaoButton = styled.button`
  display: flex;
  justify-content: center;
  align-items: center;
  width: 100%;
  height: 56px;
  border-radius: 8px;
  cursor: pointer;
  border: none;
  background-color: transparent;
  padding: 0;
`;

const KakaoButtonImage = styled.img`
  width: 100%;
  height: 100%;
  object-fit: contain;
  border-radius: 8px;
`;

export default CompletePage;
